import { Badge, Box, Button, Grid, GridItem, HStack, Separator, Table, Tag, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { Mask } from "config"
import { Styles } from "config"
import useShopping from "hooks/useShopping"
import moment from "moment"
import { useState } from "react"
import { useNavigate } from "react-router"

export default function Shopping(){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState(null)
    const [ status, setStatus ] = useState(null)
    const [ type, setType ] = useState(null)
    const list = useShopping(page, term, type, status)

    const columns = [{ children: '' }, { children: 'Status' }, { children: 'Valor', textAlign: 'right' }, { children: 'Data', textAlign: 'right' }]

    const handleResetFilters = () => {
        setStatus(null)
        setType(null)
    }

    return(
    <>
    <UI.Header title="Minhas compras" />

    <UI.Searchable placeholder="Procurar pelo ID ou código do pedido..." onChange={setTerm} value={term} />

    <Box mt={4} />

    <UI.Table loading={list.isFetching} label="Minhas compras:" columns={columns} data={list.data?.data} meta={list.data?.meta} onPageChange={value => setPage(value.page)} Row={Row} >
        <Form.Select selected={status} placeholder="Todos os status" items={[{ label: '🟡 Em análise', value: 12 }, { label: '🟢 Aprovado', value: 3 }, { label: '🔴 Cancelado', value: 5 }]} onChange={e => setStatus(e.target.value)} />
        <Form.Select selected={type} placeholder="Todos os tipos" items={[{ label: 'Produtos', value: 2 }, { label: 'Vouchers', value: 4 }]} onChange={e => setType(e.target.value)} />
        <UI.Show visible={!!status || !!type}><Button variant="ghost" size="xs" onClick={handleResetFilters}><UI.Icon name="cancel" /> Limpar filtros</Button></UI.Show>
    </UI.Table>
    </>
    )
}

const Row = ({ data }) => {

    const navigate = useNavigate()
    const status = Styles.orderStatus(data?.status)

    return(
    <Table.Row cursor="pointer" _hover={{ bg: 'rgba(0,0,0,0.1)' }} onClick={() => navigate(`/compras/${data?.id}`)}>
        <Table.Cell fontSize="xs">{data?.cod}</Table.Cell>
        <Table.Cell>
            <HStack spacing={2}>
                { data?.type === 4 ? <Badge colorPalette="purple">Vouchers</Badge> : <Badge>Produtos</Badge> }
                <Badge colorPalette={status.colorPalette}><UI.Icon name={status.icon} />{status.label}</Badge>
                <Badge>{data?.shipping_type === 1 ? 'Para envio' : 'Retirar na Matriz'}</Badge>
                { data?.parent_order_id && <Badge size="sm" colorPalette="red">Pendência</Badge> }
            </HStack>
        </Table.Cell>
        <Table.Cell textAlign="right" fontWeight="bold" color="red.fg"><UI.Number.Amount value={data?.total_amount} /></Table.Cell>
        <Table.Cell textAlign="right" fontSize="xs">{Mask.dateTime(data?.created_at)}</Table.Cell>
    </Table.Row>
    )
}
